import { useQuery } from '@tanstack/react-query';
import { jobsService } from '../services/jobs.service';
import type { JobFilters } from '../types/jobs.types';

export const JOBS_QUERY_KEY = 'jobs';

export function useJobsQuery(filters: JobFilters = {}) {
  return useQuery({
    queryKey: [JOBS_QUERY_KEY, filters],
    queryFn: () => jobsService.list(filters),
    staleTime: 1000 * 30, // 30 seconds
  });
}

export function useJobQuery(jobId: string | null) {
  return useQuery({
    queryKey: [JOBS_QUERY_KEY, jobId],
    queryFn: () => jobsService.getById(jobId!),
    enabled: !!jobId,
    refetchInterval: ({ state }) => {
      // Poll every 3s if job is in progress
      if (state.data?.status === 'pending' || state.data?.status === 'processing') {
        return 3000;
      }
      return false;
    },
  });
}

export function useJobDetailsQuery(jobId: string | null, search?: string) {
  return useQuery({
    queryKey: [JOBS_QUERY_KEY, jobId, 'details', search],
    queryFn: () => jobsService.getDetails(jobId!, search),
    enabled: !!jobId,
  });
}
